import { createApp } from 'vue'
import options from './CaseModule.options'

const el = '.kb-component--case-module'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((CaseModuleDOM) => {
            const template = CaseModuleDOM.innerHTML
            options.template = template
            const glideId = CaseModuleDOM.querySelector('.glide').id
            const component = createApp(options, { glideId }).use(Store)
            component.mount(CaseModuleDOM)
        })
    }
}
